module.exports = __webpack_public_path__ + "1414a08a691f41a39cf442d731379465.svg";